import Heroimg2 from '../components/Heroimg2'
import Navbar from '../components/Navbar'
export const PageNotFound = () => {
    return (
        <>
            <Navbar />
            <Heroimg2 heading="404 Page not found!" />
        </>
    )
}